import React from 'react';
import './styles.css';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import banner from './NOMINA/nomina_banner.png';

export default function FichaTecnicaNomina(props){


    return(<>
    <div className='contenedorGeneralFichaTecnicaNomina'>
        <div className='contenedorFichaTecnicaNomina'>
            <div className='contenedorImagenesFichaTecnicaNomina'>
                <Carousel autoPlay infiniteLoop  showArrows={false} showStatus={false} showThumbs={false} dynamicHeight={true} stopOnHover={false} interval={5000}>
                <div className='contenedorImagenCarouselNomina'><img src={banner}/>
                {/* <div className='textoOverCFDI'><h1>Gestiona, Organiza y Revisa</h1>
                <h2>cada uno de tus proyectos</h2></div> */}
                </div>
                </Carousel>
            </div>
            <div className='contenedorTextoBotonNomina'>
                <div className='contenedorTextoFichaTecnicaNomina'>
                    <p>
                       T&T NÓMINA es el sistema para la administración de la nómina que se adapta de
                       manera fácil y flexible a tus procesos de cálculo, cumple con todas las obligaciones
                       de ley y te permite hacer un pago a tus empleados en tiempo y forma.
                    </p>
                </div>
                <div>
                <a href={'https://procesos.tytsoftwaredemexico.com/aXR6bWlu/descargas/fichaTecnicaNomina.pdf'} target='_blank'>
                    <button type="button" className='botonFichaTecnicaNomina'>
                        Ver ficha técnica
                    </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
    </>)
}